module.exports = __webpack_public_path__ + "static/media/Card6.165a9d63.png";